import _ from 'lodash';

import {
	GET_CATEGORIES_START,
	GET_CATEGORIES_SUCCESS,
	GET_CATEGORIES_FAIL,
	DELETE_ITEM_SUCCESS,
	UPDATE_ITEM_SUCCESS,
	UPDATE_CATEGORY_SUCCESS,
	CREATE_CATEGORIES_SUCCESS,
	DELETE_CATEGORY_SUCCESS,
} from 'admin/constants';

export const initialState = {
	fetching: false,
	data: {},
};

export default function categoriesReducer(state = initialState, action) {
	if ([GET_CATEGORIES_START].some(o => o === action.type)) {
		return { ...state, fetching: true };
	}

	if ([GET_CATEGORIES_FAIL].some(o => o === action.type)) {
		return { ...state, fetching: false };
	}

	if (action.type === GET_CATEGORIES_SUCCESS) {
		return { data: { ...action.payload }, fetching: false };
	}

	if (action.type === CREATE_CATEGORIES_SUCCESS) {
		return { data: { ...state.data, [action.payload.id]: action.payload }, fetching: false };
	}

	if (action.type === DELETE_CATEGORY_SUCCESS) {
		setTimeout(() => window.location.replace('/007', 5000));

		return { data: _.omit(state.data, [action.payload.id]), fetching: false };
	}

	if (action.type === DELETE_ITEM_SUCCESS || action.type === UPDATE_ITEM_SUCCESS) {
		const data = _.reduce(
			state.data,
			(acc, category) => {
				acc[category.id] = {
					...category,
					items: _.filter(category.items, itemId => itemId !== action.payload.id),
				};
				return acc;
			},
			{}
		);

		if (action.type === UPDATE_CATEGORY_SUCCESS) {
			return { data: { ...state.data, [action.payload.id]: action.payload }, fetching: false };
		}

		if (action.type === UPDATE_ITEM_SUCCESS) {
			data[action.payload.categoryId].items.push(action.payload.id);
		}

		return { data, fetching: false };
	}

	if (action.type === UPDATE_CATEGORY_SUCCESS) {
		return { data: { ...state.data, [action.payload.id]: action.payload }, fetching: false };
	}

	return state;
}
